import React from 'react';
import { Layout } from 'antd';
import LayoutHeader from './header'
import MySider from './sider';

const MyLayout = props => {
    return (
        <Layout style={{ height: '100%' }}>
            <Layout.Header style={{ background: '#a61d24', padding: 0 }} >
                <LayoutHeader {...props} />
            </Layout.Header>
            <Layout style={{ height: '100%' }}>
                <MySider {...props} />
                <Layout.Content style={{ height: '100%', width: '100%', background: '#e0e0e0', padding: '8px' }}>
                    {props.children}
                </Layout.Content>
            </Layout>
        </Layout>
    );
}

export default MyLayout;